import { render } from "./admin-logo.svg?vue&type=template&id=ef3ec54e"
const script = {}
script.render = render

export default script